import { gql } from '@apollo/client';

export type UserId = string;

export type User = {
  uuid: UserId;
  displayName: string;
};

export type NewUser = Omit<User, 'id'>;

export function userFactory(overrides: Partial<User> = {}): User {
  return {
    uuid: '',
    displayName: '',
    ...overrides,
  };
}

export type UserFromApi = {
  uuid: string;
  display_name: string;
};

export const getUserFromApi = (user: UserFromApi): User => {
  return {
    uuid: user.uuid,
    displayName: user.display_name,
  };
};

export type UserFromGraphQL = {
  uuid: string;
  displayName: string;
};

export const getUserFromGraphQL = (user: UserFromGraphQL): User => {
  return {
    uuid: user.uuid,
    displayName: user.displayName,
  };
};

export const GQL_USER_FRAGMENT_NAME = 'UserFragment';
export const GQL_USER_FRAGMENT = gql`
  fragment ${GQL_USER_FRAGMENT_NAME} on User {
    uuid
    displayName
  }
`;
